import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Čísla (rok založení, počet zaměstnanců…) se do textů dosazují z src/data/site.js
// přes {{founded}}, {{employees}}, {{hallYear}}.
const resources = {
  cs: {
    translation: {
      nav: {
        home: 'Domů',
        about: 'O nás',
        services: 'Služby',
        history: 'Historie',
        gallery: 'Galerie',
        contact: 'Kontakt',
        cta: 'Poptat zakázku',
        open: 'Otevřít menu',
        close: 'Zavřít menu',
        language: 'Jazyk',
      },
      hero: {
        eyebrow: 'Zakázkové CNC obrábění · Svitavy',
        title: ['Precizní', 'CNC obrábění', 'kovových dílů.'],
        desc: 'Nabízíme komplexní služby v oblasti CNC obrábění. Spolehněte se na naši kvalitu, rychlost a přesnost.',
        ctaPrimary: 'Poptat zakázku',
        ctaSecondary: 'Naše služby',
        since: 'Na trhu od {{founded}}',
        series: 'Malé i velké série',
        scroll: 'Scroll',
      },
      about: {
        title: 'Kovoobrábění s tradicí a moderním strojovým parkem.',
        p1: 'Firma Antonín Joch vznikla v roce {{founded}} a sídlí ve Svitavách. Zabýváme se zakázkovým kovoobráběním a každý rok rozšiřujeme strojové vybavení o nové stroje.',
        p2: 'V roce {{hallYear}} jsme se přestěhovali do vlastní výrobní haly o výměře 1 000 m². Dnes máme {{employees}} zaměstnanců a zvládneme malé i velké série.',
        p3: 'Náš tým tvoří zkušení odborníci, kteří se neustále vzdělávají v nejnovějších technologiích. Rádi vám poradíme s výběrem nejefektivnějšího řešení a pomůžeme přetvořit vaše nápady v realitu.',
        imageAlt: 'Frézovací hlavy a nástroje pro CNC obrábění v dílně KOVOJOCH',
        hallAlt: 'Výrobní hala KOVOJOCH ve Svitavách',
        hallCaption: 'Výrobní hala · Svitavy',
      },
      services: {
        title: 'Co pro vás vyrobíme',
        desc: 'Vyberte technologii a prohlédněte si strojový park, na kterém vaše díly vyrobíme.',
        more: 'Strojový park',
        lathe: { name: 'Soustružení', desc: 'Moderní CNC soustruhy s precizností, kterou očekáváte.' },
        milling: { name: 'Frézování', desc: 'Vysoce výkonné CNC frézky pro přesné obrábění na míru.' },
        grinding: { name: 'Broušení', desc: 'Dokonalé broušení s důrazem na detail a kvalitu.' },
        control: { name: 'Kontrola', desc: 'Kontrolou musí projít každý kus, to je záruka kvality.' },
      },
      why: {
        title: 'Proč si vybrat právě nás?',
        items: [
          'Rychlost dodání zakázek',
          'Desítky let zkušeností v CNC technologii',
          'Dlouholetá tradice a stabilita',
          'Nejvyšší standardy kvality',
          'Inovativní technologie a moderní stroje',
        ],
        certTitle: 'Certifikováno dle ISO 9001:2015',
        certText: 'Naše certifikace je zárukou kvality a profesionality. Prohlédněte si certifikační dokument, který nás odlišuje od konkurence.',
        certShow: 'Zobrazit certifikát',
        certAlt: 'Certifikát ISO 9001:2015',
      },
      history: {
        title: 'Historie firmy',
        p1: 'Firmu založil Antonín Joch v roce <strong>{{founded}}</strong>. V roce 2016 došlo k transformaci z fyzické osoby na právnickou osobu <strong>KOVOJOCH s.r.o.</strong>',
        p2: 'Od samého počátku se specializujeme na přesné CNC třískové obrábění a neustále investujeme do nových technologií.',
        p3: 'Dokážeme pružně reagovat na objednávky a vždy zachováváme požadovanou kvalitu. V roce 2024 jsme získali certifikát řízení kvality <strong>ISO 9001:2015</strong>.',
        hint: 'Scrollujte',
        events: [
          'Založení firmy Antonín Joch',
          'První CNC frézka Hurco VMX30',
          'První víceosý soustruh Doosan',
          'Bruska na plocho Ziersch',
          'Vlastní výrobní hala 1 000 m²',
          'První 3D měřicí stroj Mitutoyo',
          'Vznik společnosti KOVOJOCH s.r.o.',
          'Přístavba haly 400 m²',
          'Certifikace ISO 9001:2015',
        ],
      },
      gallery: {
        title: 'Naše práce',
        desc: 'Podívejte se na naše produkty a práci, kterou provádíme s důrazem na detail a preciznost.',
        more: 'Zobrazit další fotky',
        less: 'Skrýt fotky',
        alt: 'Ukázka výrobku {{n}}',
        open: 'Zvětšit fotografii {{n}}',
      },
      lightbox: { close: 'Zavřít', prev: 'Předchozí', next: 'Další' },
      consent: {
        title: 'Soukromí a cookies',
        text: 'Web ukládá jen to nezbytné: zvolený jazyk a tuto volbu. Mapa Google v sekci Kontakt se načte až s vaším souhlasem, protože Google při jejím zobrazení může ukládat cookies a zpracovávat vaši IP adresu.',
        acceptAll: 'Přijmout vše',
        necessary: 'Jen nezbytné',
        settings: 'Nastavení',
        save: 'Uložit výběr',
        always: 'Vždy aktivní',
        catNecessary: 'Nezbytné',
        catNecessaryDesc: 'Zapamatování jazyka a vaší volby. Nelze vypnout.',
        catMaps: 'Mapa Google',
        catMapsDesc: 'Interaktivní mapa v sekci Kontakt (Google Ireland Ltd.).',
        mapText: 'Mapa se načítá ze služby Google Maps, která může ukládat cookies.',
        mapShow: 'Zobrazit mapu',
        footerLink: 'Nastavení cookies',
      },
      references: {
        title: 'Spolupracujeme dlouhodobě',
        desc: 'Seznam našich zákazníků, se kterými dlouhodobě spolupracujeme.',
      },
      contact: {
        title: 'Máte výkres? Pošlete nám poptávku.',
        desc: 'Stačí poslat výkres nebo popis dílu e-mailem. Ozveme se vám s cenovou nabídkou.',
        cta: 'Napsat e-mail',
        subject: 'Poptávka',
        phone: 'Telefon',
        email: 'E-mail',
        address: 'Adresa',
        ico: 'IČO',
        dic: 'DIČ',
        navigate: 'Navigovat',
        mapTitle: 'Mapa s polohou KOVOJOCH s.r.o.',
        team: 'Kontaktní osoby',
        roles: {
          ceo: 'Jednatel firmy',
          admin: 'Administrativa, nákup',
          foreman: 'Mistr výroby',
          programmer: 'Programátor, technolog',
          shipping: 'Expedice',
        },
      },
      footer: {
        nav: 'Navigace',
        services: 'Strojový park',
        contact: 'Kontakt',
        rights: 'Všechna práva vyhrazena.',
        top: 'Nahoru',
      },
      machines: {
        eyebrow: 'Strojový park',
        back: 'Zpět na služby',
        ctaTitle: 'Potřebujete něco vyrobit?',
        ctaText: 'Pošlete nám výkres a my navrhneme nejefektivnější způsob výroby.',
        lathe: {
          title: 'CNC soustružení',
          desc: 'CNC soustružení je ideální metoda pro obrábění rotačních dílů s vysokou přesností. Na našich moderních soustruzích dokážeme opracovat širokou škálu materiálů.',
        },
        milling: {
          title: 'CNC frézování',
          desc: 'CNC frézování se vyznačuje vysokou přesností, rychlým zpracováním a širokými možnostmi využití. Opracujeme různé materiály od standardních ocelí přes slitiny a neželezné kovy až po kalené nástrojové oceli.',
        },
        grinding: {
          title: 'CNC broušení',
          desc: 'CNC broušení zajišťuje maximální přesnost při zpracování materiálů. Naše stroje pro broušení na plocho a na kulato jsou ideální pro dokončovací práce s vysokou precizností.',
          flat: 'Broušení na plocho',
          round: 'Broušení na kulato',
        },
        control: {
          title: 'Kontrola kvality',
          desc: 'Naše měřicí přístroje zajišťují maximální přesnost a kvalitu každého dílu. Díky pokročilým technologiím a precizní kalibraci získáte data potřebná pro efektivní řízení kvality.',
        },
        specs: {
          maxTurnDia: 'Max. průměr soustružení',
          maxTurnLen: 'Max. délka soustružení',
          maxSpindle: 'Max. otáčky vřetena',
          tableSize: 'Upínací plocha stolu',
          maxLoad: 'Max. zatížení stolu',
          rangeXYZ: 'Pracovní rozsah XYZ (AC)',
          workRange: 'Pracovní rozsah',
          maxDia: 'Max. průměr obrobku',
          maxLen: 'Max. délka obrobku',
          spindle: 'Otáčky vřetena',
          accuracy: 'Přesnost měření',
          measRange: 'Rozsah měření',
          interface: 'Typ rozhraní',
        },
        values: { digital: 'Digitální', analog: 'Analogový' },
        names: {
          cmm: '3D měřicí stroj Mitutoyo',
          height: 'Výškoměr',
          roughness: 'Drsnoměr',
          roundness: 'Kruhoměr',
        },
      },
    },
  },

  en: {
    translation: {
      nav: {
        home: 'Home',
        about: 'About',
        services: 'Services',
        history: 'History',
        gallery: 'Gallery',
        contact: 'Contact',
        cta: 'Request a quote',
        open: 'Open menu',
        close: 'Close menu',
        language: 'Language',
      },
      hero: {
        eyebrow: 'Custom CNC machining · Svitavy, Czech Republic',
        title: ['Precision', 'CNC machining', 'of metal parts.'],
        desc: 'We offer comprehensive services in the field of CNC machining. Rely on our quality, speed and precision.',
        ctaPrimary: 'Request a quote',
        ctaSecondary: 'Our services',
        since: 'On the market since {{founded}}',
        series: 'Small and large series',
        scroll: 'Scroll',
      },
      about: {
        title: 'Metal machining with tradition and a modern machine park.',
        p1: 'The company Antonín Joch was founded in {{founded}} and is based in Svitavy, Czech Republic. We specialise in custom metal machining and expand our machinery with new machines every year.',
        p2: 'In {{hallYear}} we moved into our own production hall with an area of 1,000 m². Today we employ {{employees}} people and handle both small and large series.',
        p3: 'Our team is made up of experienced experts who constantly keep up with the latest technologies. We will gladly advise you on the most efficient solution and help turn your ideas into reality.',
        imageAlt: 'Milling heads and CNC cutting tools in the KOVOJOCH workshop',
        hallAlt: 'KOVOJOCH production hall in Svitavy',
        hallCaption: 'Production hall · Svitavy',
      },
      services: {
        title: 'What we make for you',
        desc: 'Choose a technology and explore the machines we will use to make your parts.',
        more: 'Machine park',
        lathe: { name: 'Turning', desc: 'Modern CNC lathes with the precision you expect.' },
        milling: { name: 'Milling', desc: 'High-performance CNC milling machines for precise custom machining.' },
        grinding: { name: 'Grinding', desc: 'Perfect grinding with an emphasis on detail and quality.' },
        control: { name: 'Inspection', desc: 'Every piece must pass inspection. This is our guarantee of quality.' },
      },
      why: {
        title: 'Why choose us?',
        items: [
          'Fast order delivery',
          'Decades of experience in CNC technology',
          'Long-standing tradition and stability',
          'Highest quality standards',
          'Innovative technology and modern machinery',
        ],
        certTitle: 'Certified to ISO 9001:2015',
        certText: 'Our certification is a guarantee of quality and professionalism. View the certification document that sets us apart from the competition.',
        certShow: 'View certificate',
        certAlt: 'ISO 9001:2015 certificate',
      },
      history: {
        title: 'Company history',
        p1: 'The company was founded by Antonín Joch in <strong>{{founded}}</strong>. In 2016 the sole proprietorship was transformed into the limited liability company <strong>KOVOJOCH s.r.o.</strong>',
        p2: 'From the very beginning we have specialised in precise CNC machining and continually invest in new technologies.',
        p3: 'We respond flexibly to orders while always maintaining the required quality. In 2024 we obtained the <strong>ISO 9001:2015</strong> quality management certification.',
        hint: 'Keep scrolling',
        events: [
          'Antonín Joch company founded',
          'First CNC milling machine Hurco VMX30',
          'First multi-axis Doosan lathe',
          'Ziersch surface grinder',
          'Own 1,000 m² production hall',
          'First Mitutoyo 3D measuring machine',
          'KOVOJOCH s.r.o. established',
          '400 m² hall extension',
          'ISO 9001:2015 certification',
        ],
      },
      gallery: {
        title: 'Our work',
        desc: 'Take a look at our products and the work we do with an emphasis on detail and precision.',
        more: 'Show more photos',
        less: 'Show fewer photos',
        alt: 'Product sample {{n}}',
        open: 'Enlarge photo {{n}}',
      },
      lightbox: { close: 'Close', prev: 'Previous', next: 'Next' },
      consent: {
        title: 'Privacy and cookies',
        text: 'This site only stores what is necessary: your language and this choice. The Google map in the Contact section loads only with your consent, because Google may set cookies and process your IP address when it is displayed.',
        acceptAll: 'Accept all',
        necessary: 'Necessary only',
        settings: 'Settings',
        save: 'Save selection',
        always: 'Always active',
        catNecessary: 'Necessary',
        catNecessaryDesc: 'Remembers your language and this choice. Cannot be turned off.',
        catMaps: 'Google Maps',
        catMapsDesc: 'Interactive map in the Contact section (Google Ireland Ltd.).',
        mapText: 'The map is loaded from Google Maps, which may set cookies.',
        mapShow: 'Show map',
        footerLink: 'Cookie settings',
      },
      references: {
        title: 'Long-term partners',
        desc: 'A list of our customers with whom we have long-term cooperation.',
      },
      contact: {
        title: 'Got a drawing? Send us an inquiry.',
        desc: 'Just send us a drawing or a description of the part by e-mail and we will get back to you with a quote.',
        cta: 'Send an e-mail',
        subject: 'Inquiry',
        phone: 'Phone',
        email: 'E-mail',
        address: 'Address',
        ico: 'Company ID',
        dic: 'VAT ID',
        navigate: 'Get directions',
        mapTitle: 'Map showing KOVOJOCH s.r.o.',
        team: 'Contact persons',
        roles: {
          ceo: 'Managing director',
          admin: 'Administration, purchasing',
          foreman: 'Production foreman',
          programmer: 'CNC programmer, technologist',
          shipping: 'Shipping',
        },
      },
      footer: {
        nav: 'Navigation',
        services: 'Machine park',
        contact: 'Contact',
        rights: 'All rights reserved.',
        top: 'Back to top',
      },
      machines: {
        eyebrow: 'Machine park',
        back: 'Back to services',
        ctaTitle: 'Need something made?',
        ctaText: 'Send us a drawing and we will propose the most efficient way to produce it.',
        lathe: {
          title: 'CNC turning',
          desc: 'CNC turning is the ideal method for machining rotational parts with high precision. Our modern lathes can process a wide range of materials.',
        },
        milling: {
          title: 'CNC milling',
          desc: 'CNC milling offers high precision, fast processing and a wide range of applications. We machine everything from standard steels through alloys and non-ferrous metals to hardened tool steels.',
        },
        grinding: {
          title: 'CNC grinding',
          desc: 'CNC grinding ensures maximum precision. Our surface and cylindrical grinders are ideal for high-precision finishing work.',
          flat: 'Surface grinding',
          round: 'Cylindrical grinding',
        },
        control: {
          title: 'Quality inspection',
          desc: 'Our measuring instruments ensure maximum accuracy and quality of every part. Advanced technology and precise calibration give you the data needed for effective quality management.',
        },
        specs: {
          maxTurnDia: 'Max. turning diameter',
          maxTurnLen: 'Max. turning length',
          maxSpindle: 'Max. spindle speed',
          tableSize: 'Table clamping area',
          maxLoad: 'Max. table load',
          rangeXYZ: 'Working range XYZ (AC)',
          workRange: 'Working range',
          maxDia: 'Max. workpiece diameter',
          maxLen: 'Max. workpiece length',
          spindle: 'Spindle speed',
          accuracy: 'Measuring accuracy',
          measRange: 'Measuring range',
          interface: 'Interface',
        },
        values: { digital: 'Digital', analog: 'Analogue' },
        names: {
          cmm: 'Mitutoyo 3D coordinate measuring machine',
          height: 'Height gauge',
          roughness: 'Surface roughness tester',
          roundness: 'Roundness tester',
        },
      },
    },
  },

  de: {
    translation: {
      nav: {
        home: 'Startseite',
        about: 'Über uns',
        services: 'Leistungen',
        history: 'Geschichte',
        gallery: 'Galerie',
        contact: 'Kontakt',
        cta: 'Anfrage senden',
        open: 'Menü öffnen',
        close: 'Menü schließen',
        language: 'Sprache',
      },
      hero: {
        eyebrow: 'CNC-Lohnfertigung · Svitavy, Tschechien',
        title: ['Präzise', 'CNC-Bearbeitung', 'von Metallteilen.'],
        desc: 'Wir bieten umfassende Dienstleistungen im Bereich der CNC-Bearbeitung. Verlassen Sie sich auf unsere Qualität, Schnelligkeit und Präzision.',
        ctaPrimary: 'Anfrage senden',
        ctaSecondary: 'Unsere Leistungen',
        since: 'Am Markt seit {{founded}}',
        series: 'Kleine und große Serien',
        scroll: 'Scroll',
      },
      about: {
        title: 'Zerspanung mit Tradition und modernem Maschinenpark.',
        p1: 'Die Firma Antonín Joch wurde {{founded}} gegründet und hat ihren Sitz in Svitavy, Tschechien. Wir sind auf kundenspezifische Metallbearbeitung spezialisiert und erweitern unseren Maschinenpark jedes Jahr um neue Maschinen.',
        p2: '{{hallYear}} sind wir in unsere eigene Produktionshalle mit 1.000 m² umgezogen. Heute beschäftigen wir {{employees}} Mitarbeiter und fertigen sowohl kleine als auch große Serien.',
        p3: 'Unser Team besteht aus erfahrenen Fachleuten, die sich ständig in den neuesten Technologien weiterbilden. Wir beraten Sie gerne bei der Wahl der effizientesten Lösung und helfen Ihnen, Ihre Ideen umzusetzen.',
        imageAlt: 'Fräsköpfe und CNC-Werkzeuge in der Werkstatt von KOVOJOCH',
        hallAlt: 'Produktionshalle von KOVOJOCH in Svitavy',
        hallCaption: 'Produktionshalle · Svitavy',
      },
      services: {
        title: 'Was wir für Sie fertigen',
        desc: 'Wählen Sie eine Technologie und sehen Sie sich den Maschinenpark an, auf dem wir Ihre Teile fertigen.',
        more: 'Maschinenpark',
        lathe: { name: 'Drehen', desc: 'Moderne CNC-Drehmaschinen mit der Präzision, die Sie erwarten.' },
        milling: { name: 'Fräsen', desc: 'Hochleistungs-CNC-Fräsmaschinen für präzise Bearbeitung nach Maß.' },
        grinding: { name: 'Schleifen', desc: 'Perfektes Schleifen mit Fokus auf Detail und Qualität.' },
        control: { name: 'Kontrolle', desc: 'Jedes Teil wird geprüft. Das ist unsere Qualitätsgarantie.' },
      },
      why: {
        title: 'Warum uns wählen?',
        items: [
          'Schnelle Auftragsabwicklung',
          'Jahrzehntelange Erfahrung in der CNC-Technologie',
          'Langjährige Tradition und Stabilität',
          'Höchste Qualitätsstandards',
          'Innovative Technologien und moderne Maschinen',
        ],
        certTitle: 'Zertifiziert nach ISO 9001:2015',
        certText: 'Unsere Zertifizierung ist eine Garantie für Qualität und Professionalität. Sehen Sie sich das Zertifikat an, das uns von der Konkurrenz abhebt.',
        certShow: 'Zertifikat anzeigen',
        certAlt: 'Zertifikat ISO 9001:2015',
      },
      history: {
        title: 'Firmengeschichte',
        p1: 'Das Unternehmen wurde <strong>{{founded}}</strong> von Antonín Joch gegründet. 2016 erfolgte die Umwandlung des Einzelunternehmens in die <strong>KOVOJOCH s.r.o.</strong>',
        p2: 'Von Anfang an haben wir uns auf präzise CNC-Zerspanung spezialisiert und investieren laufend in neue Technologien.',
        p3: 'Wir reagieren flexibel auf Aufträge und halten stets die geforderte Qualität ein. 2024 haben wir das Qualitätsmanagementzertifikat <strong>ISO 9001:2015</strong> erlangt.',
        hint: 'Weiter scrollen',
        events: [
          'Gründung der Firma Antonín Joch',
          'Erste CNC-Fräsmaschine Hurco VMX30',
          'Erste mehrachsige Doosan-Drehmaschine',
          'Flachschleifmaschine Ziersch',
          'Eigene Produktionshalle mit 1.000 m²',
          'Erste 3D-Messmaschine Mitutoyo',
          'Gründung der KOVOJOCH s.r.o.',
          'Hallenerweiterung um 400 m²',
          'Zertifizierung ISO 9001:2015',
        ],
      },
      gallery: {
        title: 'Unsere Arbeit',
        desc: 'Werfen Sie einen Blick auf unsere Produkte und unsere Arbeit, die wir mit Fokus auf Detail und Präzision ausführen.',
        more: 'Weitere Fotos anzeigen',
        less: 'Weniger Fotos anzeigen',
        alt: 'Produktbeispiel {{n}}',
        open: 'Foto {{n}} vergrößern',
      },
      lightbox: { close: 'Schließen', prev: 'Zurück', next: 'Weiter' },
      consent: {
        title: 'Datenschutz und Cookies',
        text: 'Diese Website speichert nur das Nötigste: Ihre Sprache und diese Auswahl. Die Google-Karte im Bereich Kontakt wird erst mit Ihrer Zustimmung geladen, da Google dabei Cookies setzen und Ihre IP-Adresse verarbeiten kann.',
        acceptAll: 'Alle akzeptieren',
        necessary: 'Nur notwendige',
        settings: 'Einstellungen',
        save: 'Auswahl speichern',
        always: 'Immer aktiv',
        catNecessary: 'Notwendig',
        catNecessaryDesc: 'Speichert Ihre Sprache und diese Auswahl. Kann nicht deaktiviert werden.',
        catMaps: 'Google Maps',
        catMapsDesc: 'Interaktive Karte im Bereich Kontakt (Google Ireland Ltd.).',
        mapText: 'Die Karte wird von Google Maps geladen, das Cookies setzen kann.',
        mapShow: 'Karte anzeigen',
        footerLink: 'Cookie-Einstellungen',
      },
      references: {
        title: 'Langjährige Partner',
        desc: 'Eine Liste unserer Kunden, mit denen wir langfristig zusammenarbeiten.',
      },
      contact: {
        title: 'Sie haben eine Zeichnung? Senden Sie uns Ihre Anfrage.',
        desc: 'Senden Sie uns einfach eine Zeichnung oder Beschreibung des Teils per E-Mail. Wir melden uns mit einem Angebot.',
        cta: 'E-Mail schreiben',
        subject: 'Anfrage',
        phone: 'Telefon',
        email: 'E-Mail',
        address: 'Adresse',
        ico: 'Firmen-ID',
        dic: 'USt-IdNr.',
        navigate: 'Route planen',
        mapTitle: 'Karte mit Standort der KOVOJOCH s.r.o.',
        team: 'Ansprechpartner',
        roles: {
          ceo: 'Geschäftsführer',
          admin: 'Verwaltung, Einkauf',
          foreman: 'Fertigungsmeister',
          programmer: 'CNC-Programmierer, Technologe',
          shipping: 'Versand',
        },
      },
      footer: {
        nav: 'Navigation',
        services: 'Maschinenpark',
        contact: 'Kontakt',
        rights: 'Alle Rechte vorbehalten.',
        top: 'Nach oben',
      },
      machines: {
        eyebrow: 'Maschinenpark',
        back: 'Zurück zu den Leistungen',
        ctaTitle: 'Brauchen Sie ein Teil?',
        ctaText: 'Senden Sie uns eine Zeichnung und wir schlagen die effizienteste Fertigungsweise vor.',
        lathe: {
          title: 'CNC-Drehen',
          desc: 'CNC-Drehen ist die ideale Methode zur hochpräzisen Bearbeitung rotationssymmetrischer Teile. Auf unseren modernen Drehmaschinen bearbeiten wir eine breite Palette von Werkstoffen.',
        },
        milling: {
          title: 'CNC-Fräsen',
          desc: 'CNC-Fräsen zeichnet sich durch hohe Präzision, schnelle Bearbeitung und vielseitige Einsatzmöglichkeiten aus. Wir bearbeiten Werkstoffe von Standardstählen über Legierungen und NE-Metalle bis zu gehärteten Werkzeugstählen.',
        },
        grinding: {
          title: 'CNC-Schleifen',
          desc: 'CNC-Schleifen gewährleistet höchste Präzision. Unsere Flach- und Rundschleifmaschinen sind ideal für hochpräzise Endbearbeitung.',
          flat: 'Flachschleifen',
          round: 'Rundschleifen',
        },
        control: {
          title: 'Qualitätskontrolle',
          desc: 'Unsere Messgeräte sichern höchste Genauigkeit und Qualität jedes Teils. Moderne Technik und präzise Kalibrierung liefern die Daten für ein effektives Qualitätsmanagement.',
        },
        specs: {
          maxTurnDia: 'Max. Drehdurchmesser',
          maxTurnLen: 'Max. Drehlänge',
          maxSpindle: 'Max. Spindeldrehzahl',
          tableSize: 'Tischaufspannfläche',
          maxLoad: 'Max. Tischbelastung',
          rangeXYZ: 'Arbeitsbereich XYZ (AC)',
          workRange: 'Arbeitsbereich',
          maxDia: 'Max. Werkstückdurchmesser',
          maxLen: 'Max. Werkstücklänge',
          spindle: 'Spindeldrehzahl',
          accuracy: 'Messgenauigkeit',
          measRange: 'Messbereich',
          interface: 'Schnittstelle',
        },
        values: { digital: 'Digital', analog: 'Analog' },
        names: {
          cmm: 'Mitutoyo 3D-Koordinatenmessmaschine',
          height: 'Höhenmessgerät',
          roughness: 'Rauheitsmessgerät',
          roundness: 'Formmessgerät (Rundheit)',
        },
      },
    },
  },
};

const LANGS = ['cs', 'en', 'de'];

const savedLanguage = () => {
  try {
    const lng = localStorage.getItem('lng');
    return LANGS.includes(lng) ? lng : 'cs';
  } catch {
    return 'cs';
  }
};

i18n.use(initReactI18next).init({
  resources,
  lng: savedLanguage(),
  fallbackLng: 'cs',
  interpolation: { escapeValue: false },
});

const syncHtmlLang = (lng) => {
  document.documentElement.lang = lng;
  try {
    localStorage.setItem('lng', lng);
  } catch {
    // úložiště může být zablokované – jazyk se pak jen nezapamatuje
  }
};
syncHtmlLang(i18n.language);
i18n.on('languageChanged', syncHtmlLang);

export { LANGS };
export default i18n;
